import ChatMember from 'entities/ChatMember';
import Collection from 'lib/Collection';
import Subscriber from 'entities/Subscriber';
import User from 'entities/User';

class ChatMembers extends Collection<ChatMember> {
  initialize() {
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof ChatMember' is missing the following ... Remove this comment to see the full error message
    this.model = ChatMember;
  }

  static buildChatMember(user: User | Subscriber): ChatMember {
    return new ChatMember({
      id: user.id,
      uuid: user.getUuid(),
      name: user.getSignature() || user.getName(),
      role: user.getRole(),
      office_hours: user.getOfficeHours(),
      contactability_status: user.getContactabilityStatus(),
      color: user.getColor(),
      initials: user.getInitials(),
    });
  }
}

export default ChatMembers;
